import { useRef, useEffect } from 'react';
import Hls from 'hls.js';

interface Props {
  url: string;
  onEnded?: any;
  autoplay?: boolean;
}

const VideoPlayer = ({ url, onEnded = () => {}, autoplay = true }: Props) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    let hls: Hls | null = null;

    if (videoRef.current && url) {
      if (Hls.isSupported()) {
        hls = new Hls({
          maxBufferLength: 30,
          maxMaxBufferLength: 60,
          maxBufferSize: 60 * 1000 * 1000, // 60MB
          maxBufferHole: 0.5,
          lowLatencyMode: true,
          backBufferLength: 90, // Guardar 90 segundos en el buffer para evitar recargas
        });

        hls.loadSource(url);
        hls.attachMedia(videoRef.current);

        hls.on(Hls.Events.ERROR, (ev, data) => {
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.error('Network error', data);
                hls.startLoad();
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.error('Media error', data);
                hls.recoverMediaError();
                break;
              default:
                console.error('Unrecoverable error', data);
                hls.destroy();
                break;
            }
          }
        });
      } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        videoRef.current.src = url;
      } else {
        console.error('HLS is not supported and the MIME type is not supported either.');
      }
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [url]);

  return (
    <div>
      <video ref={videoRef} autoPlay={autoplay} controls style={{ width: '100%', height: '100%' }} onEnded={onEnded} />
    </div>
  );
};

export default VideoPlayer;
